import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import httpService from "../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../helpers/numbers";
import helperSpinner from "../../../../helpers/spinner";
import StatePositionConstant from "./../StatePositionConstant";

export default function SetStatePosition({ position }) {
  const positionID = position.pop_id;
  let statusPositions = StatePositionConstant.statusPosition;
  const history = useHistory();

  const [hiliteCommission, setHiliteCommission] = useState(
    position.pop_hilite_commission
  );
  const [publisherRight, setPublisherRight] = useState(
    position.pop_publisher_right
  );

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const setStatePosition = async (formBody) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestSetStatePositionRejectOrSendSuggestion(
      positionID,
      formBody
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!result) {
      return;
    }

    if (position.pop_page_id == 0) {
      history.push(
        `/position/manage/independent/publisher/${position.pop_publisher_id}`
      );
      return;
    }
    history.push(`/position/manage/page/${position.pop_page_id}`);
  };

  const sendRequestSetStatePositionRejectOrSendSuggestion = async (
    positionID,
    formBody
  ) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/position/${positionID}/set-state`,
        formBody,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const getBadgeTypeClassStatePosition = (statePosition) => {
    let classNameBadgeType;
    switch (statePosition) {
      case StatePositionConstant.statusPosition.PENDING:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.SEND_SUGGESTION_TO_PUBLISHER:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition.DISAGREE_FROM_PUBLISHER:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition.AGREE_FROM_PUBLISHER:
        classNameBadgeType = "primary";
        break;
      case StatePositionConstant.statusPosition.CONFIRM:
        classNameBadgeType = "success";
        break;

      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_PENDING_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "warning";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_DISAGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "danger";
        break;
      case StatePositionConstant.statusPosition
        .ALREADY_CONFIRMED_AGREE_SUGGESTION_FROM_PUBLISHER_FOR_EDIT:
        classNameBadgeType = "primary";
        break;
    }
    return classNameBadgeType;
  };

  const inputHiliteCommissionChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setHiliteCommission(parseInt(number));
  };

  const inputPublisherRightChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setPublisherRight(parseInt(number));
  };

  const preventEnterLetterOnInput = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateFormForSetInfoPositionForConfirmPosition = () => {
    return (
      <>
        <hr />
        <div className="alert alert-primary">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            پیشنهاد ارسال شده ما به نمایش دهنده :{" "}
          </p>
          <p className="text-justify" style={{ whiteSpace: "pre-line" }}>
            {position.pop_message}
          </p>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setStatePosition({
              state: StatePositionConstant.statusPosition.CONFIRM + "",
              hilite_commission: hiliteCommission,
              publisher_right: publisherRight,
            });
          }}
        >
          <div className="form-group">
            <label>حق نمایش دهنده (تومان)</label>
            <input
              tabIndex="2"
              type="text"
              id="publisher-right"
              className="form-control number-finance"
              value={helpersNumbers.toPersianNum(
                helpersNumbers.toFormatFinanceNumber(publisherRight)
              )}
              onChange={inputPublisherRightChangeHandler}
              onBeforeInput={preventEnterLetterOnInput}
              dir="ltr"
              required
            />
          </div>

          <div className="form-group">
            <label>کمسیسون هایلات (تومان)</label>
            <input
              tabIndex="2"
              type="text"
              id="hilite-commission"
              className="form-control number-finance"
              value={helpersNumbers.toPersianNum(
                helpersNumbers.toFormatFinanceNumber(hiliteCommission)
              )}
              onChange={inputHiliteCommissionChangeHandler}
              onBeforeInput={preventEnterLetterOnInput}
              dir="ltr"
              required
            />
          </div>

          <div className="form-group">
            <button className="btn btn-success">درج اطلاعات</button>
          </div>
        </form>
      </>
    );
  };

  const setTagHtmlToPosition = async (formBody) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestSetTagHtmlToPosition(positionID, formBody);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!result) {
      return;
    }

    if (position.pop_page_id == 0) {
      history.push(
        `/position/manage/independent/publisher/${position.pop_publisher_id}`
      );
      return;
    }
    history.push(`/position/manage/page/${position.pop_page_id}`);
  };

  const sendRequestSetTagHtmlToPosition = async (positionID, formBody) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          `/v1/manage/publisher/position/${positionID}/set-position-html-tag-ID`,
        formBody,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateFormForSetTagHtmlIDPosition = () => {
    return (
      <>
        <hr />
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setTagHtmlToPosition({
              tag_html_ID: document.querySelector("#tag-html-id").value.trim(),
            });
          }}
        >
          <div className="form-group">
            <label>درج جایگاه html </label>
            <input className="form-control" id="tag-html-id" required />
          </div>
          <div className="form-group">
            <button className="btn btn-success">درج جایگاه</button>
          </div>
        </form>
      </>
    );
  };

  return (
    <div className="pt-2">
      <hr />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setStatePosition({
            state: document.querySelector("#state").value,
            message: document.querySelector("#message").value,
          });
        }}
      >
        <div>
          <label>حالت فعلی جایگاه : </label>
          <label
            className={`badge badge-${getBadgeTypeClassStatePosition(
              position.pop_state
            )}`}
          >
            {
              StatePositionConstant.getStatusPositionString()[
                position.pop_state
              ]
            }
          </label>
        </div>
        <div className="alert alert-warning ">
          <p>
            <i className="fa fa-info pl-2"></i> توجه داشته باشید:{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p>
                در صورت تایید موقت و ارسال پیشنهاد به نمایش دهنده جمع مبلغ حق
                نمایش دهنده و مبلغ سهم هایلات باید برابر با مبلغ قیمت جایگاه
                باشد.
              </p>
            </li>
          </ul>
        </div>
        <div className="form-group d-flex align-items-center">
          <div className="pl-3">
            <label className="m-0">حالت جایگاه</label>
          </div>

          <div>
            <select className="form-control d-block" id="state">
              {position["temporary"] ? (
                <>
                  {" "}
                  <option
                    value={
                      StatePositionConstant.statusPosition
                        .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
                    }
                  >
                    {
                      StatePositionConstant.getStatusPositionString()[
                        StatePositionConstant.statusPosition
                          .ALREADY_CONFIRMED_SEND_SUGGESTION_TO_PUBLISHER_FOR_EDIT
                      ]
                    }
                  </option>
                  <option
                    value={
                      StatePositionConstant.statusPosition
                        .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
                    }
                  >
                    {
                      StatePositionConstant.getStatusPositionString()[
                        StatePositionConstant.statusPosition
                          .ALREADY_CONFIRMED_REJECT_FROM_OPERATOR_FOR_EDIT
                      ]
                    }
                  </option>
                </>
              ) : (
                <>
                  {" "}
                  <option
                    value={
                      StatePositionConstant.statusPosition
                        .SEND_SUGGESTION_TO_PUBLISHER
                    }
                  >
                    {
                      StatePositionConstant.getStatusPositionString()[
                        StatePositionConstant.statusPosition
                          .SEND_SUGGESTION_TO_PUBLISHER
                      ]
                    }
                  </option>
                  <option
                    value={
                      StatePositionConstant.statusPosition.REJECT_FROM_OPERATOR
                    }
                  >
                    {
                      StatePositionConstant.getStatusPositionString()[
                        StatePositionConstant.statusPosition
                          .REJECT_FROM_OPERATOR
                      ]
                    }
                  </option>
                </>
              )}
            </select>
          </div>
        </div>
        <div className="form-group">
          <label>متن پیغام برای کاربر نمایش دهنده</label>
          <textarea
            className="form-control"
            id="message"
            cols="30"
            rows="10"
            required
          ></textarea>
        </div>
        <div>
          <button type="submit" className="btn btn-success">
            اعمال
          </button>
        </div>
      </form>

      {generateFormForSetInfoPositionForConfirmPosition()}
      {generateFormForSetTagHtmlIDPosition()}
    </div>
  );
}
